import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import addOrInviteWorker from "../../services/addWorkerDetails";
import authService from "../../services/authService";
import { setGlobalWorkerStatus } from "../../services/workers";
export const addWorker = createAsyncThunk(
  "addWorker/addWorker",
  async (workerDetails, thunkAPI) => {
    try {
      const data = await addOrInviteWorker.addWorkerDetails(workerDetails);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const updateWorker = createAsyncThunk(
  "addWorker/updateWorker",
  async (workerDetails, thunkAPI) => {
    try {
      const data = await addOrInviteWorker.updateWorkerDetails(workerDetails);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateWorkerExp = createAsyncThunk(
  "addWorker/updateWorkerExp",
  async (workerDetails, thunkAPI) => {
    try {
      const data = await addOrInviteWorker.updateWorkerDetailsExp(
        workerDetails
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const changeWorkerStatus = createAsyncThunk(
  "changeWorkerStatus/changeWorkerStatus",
  async (params, thunkAPI) => {
    try {
      const data = await addOrInviteWorker.changeWorkerStaus(params);
      console.log(data, "data");
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const inviteWorker = createAsyncThunk(
  "addWorker/inviteWorker",
  async (inviteWorkerDetails, thunkAPI) => {
    try {
      const data = await addOrInviteWorker.inviteWorkerApi(inviteWorkerDetails);
      return { inviteWorkerResponse: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const changeWorkerStatusGlobal = createAsyncThunk(
  "changeWorkerStatus/changeWorkerStatusGlobal",
  async (params, thunkAPI) => {
    try {
      const data = await setGlobalWorkerStatus(params);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


const initialState = {
  response: null,
  inviteWorkerResponse: null,
  workerDetails: {},
  changeWorkerStatus: {},
};
const addWorkerSlice = createSlice({
  name: "addWorker",
  initialState,
  extraReducers: {
    [addWorker.fulfilled]: (state, action) => {
      state.response = action.payload.response;
      state.workerDetails = action.payload.response.data;
    },
    [addWorker.rejected]: (state, action) => {
      state.response = null;
      state.message = action.payload;
    },
    [inviteWorker.fulfilled]: (state, action) => {
      state.inviteWorkerResponse = action.payload.inviteWorkerResponse;
    },
    [inviteWorker.rejected]: (state, action) => {
      state.inviteWorkerResponse = null;
      state.message = action.payload;
    },
    [changeWorkerStatus.fulfilled]: (state, action) => {
      state.response = action.payload.response;
      state.changeWorkerStatus = action.payload.response.data;
    },
    [changeWorkerStatus.rejected]: (state, action) => {
      state.response = null;
      state.message = action.payload;
    },
  },
});
const { reducer } = addWorkerSlice;
export default reducer;
